import { Link } from 'react-router-dom';
import { colors } from '../styles/design-tokens';

export default function Footer() {
  return (
    <footer style={{ borderTop: `1px solid ${colors.border}` }}>
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/assets/icon.svg" alt="NorthStar" className="h-7 w-7" />
              <span className="font-semibold" style={{ color: colors.cream }}>NorthStar Aurora</span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: colors.textMuted }}>
              The next generation all-in-one pixel design platform.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold mb-3" style={{ color: colors.cream }}>Product</h4>
            <div className="space-y-2">
              <Link to="/features" className="block text-sm transition hover:opacity-100" style={{ color: colors.textSecondary, opacity: 0.8 }}>Features</Link>
              <Link to="/compatibility" className="block text-sm transition hover:opacity-100" style={{ color: colors.textSecondary, opacity: 0.8 }}>Compatibility</Link>
              <Link to="/waitlist" className="block text-sm transition hover:opacity-100" style={{ color: colors.textSecondary, opacity: 0.8 }}>Join Waitlist</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold mb-3" style={{ color: colors.cream }}>Company</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm transition hover:opacity-100" style={{ color: colors.textSecondary, opacity: 0.8 }}>About</Link>
              <Link to="/contact" className="block text-sm transition hover:opacity-100" style={{ color: colors.textSecondary, opacity: 0.8 }}>Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-3" style={{ color: colors.cream }}>Get in Touch</h4>
            <a
              href="mailto:customerservice@northstaraurora.tech"
              className="text-sm transition hover:opacity-100"
              style={{ color: colors.gold, opacity: 0.9 }}
            >
              customerservice@northstaraurora.tech
            </a>
            <p className="text-sm mt-2" style={{ color: colors.textMuted }}>Albuquerque, New Mexico</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 flex flex-col md:flex-row justify-between items-center gap-4" style={{ borderTop: `1px solid ${colors.border}` }}>
          <p className="text-xs" style={{ color: colors.textDim }}>
            &copy; 2026 NorthStar Aurora. All rights reserved.
          </p>
          <div className="flex gap-4 text-xs" style={{ color: colors.textDim }}>
            <Link to="/about" className="hover:opacity-80 transition">About</Link>
            <Link to="/contact" className="hover:opacity-80 transition">Contact</Link>
            <a href="mailto:customerservice@northstaraurora.tech" className="hover:opacity-80 transition">Support</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
